import { render, staticRenderFns } from "./ProjectsEdit.vue?vue&type=template&id=62ce04e9"
import script from "./ProjectsEdit.vue?vue&type=script&lang=js"
export * from "./ProjectsEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports